import _styled from "styled-components";
var _excluded = ["className", "style", "children", "placement", "variant", "padding"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType, variantSwitch } from '@adsk/alloy-react-helpers';
import theme from '@adsk/alloy-react-theme';
import { PLACEMENTS, VARIANTS, getMainAxisPlacement } from '../consts';
var Container = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _variants, _variants2;

  var className = _ref.className,
      style = _ref.style,
      children = _ref.children,
      placement = _ref.placement,
      variant = _ref.variant,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? '0' : _ref$padding,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    ref: ref,
    className: className
  }, props, {
    $_css: [{
      position: 'absolute',
      left: 0,
      top: 0,
      margin: 0,
      right: 'auto',
      bottom: 'auto',
      zIndex: theme.zIndex.tooltip
    }, variantSwitch({
      statement: getMainAxisPlacement(placement),
      variants: (_variants = {}, _defineProperty(_variants, PLACEMENTS.LEFT, {
        padding: "0 ".concat(padding)
      }), _defineProperty(_variants, PLACEMENTS.RIGHT, {
        padding: "0 ".concat(padding)
      }), _defineProperty(_variants, PLACEMENTS.TOP, {
        padding: "".concat(padding, " 0")
      }), _defineProperty(_variants, PLACEMENTS.BOTTOM, {
        padding: "".concat(padding, " 0")
      }), _variants)
    }), variantSwitch({
      statement: variant,
      variants: (_variants2 = {}, _defineProperty(_variants2, VARIANTS.LIGHT, {
        color: theme.colors.charcoal900,
        backgroundColor: theme.colors.white,
        borderRadius: 4,
        boxShadow: theme.shadows.highElevation
      }), _defineProperty(_variants2, VARIANTS.DARK, {
        color: theme.colors.white,
        backgroundColor: theme.colors.charcoal900,
        borderRadius: 2
      }), _variants2)
    }), style]
  }), children);
});
Container.displayName = 'Container';
Container.defaultProps = {
  padding: '0'
};
Container.propTypes = {
  /** className */
  className: PropTypes.string,

  /** style */
  style: stylePropType,

  /** placement */
  placement: PropTypes.oneOf(Object.values(PLACEMENTS)),

  /** children */
  children: PropTypes.node,

  /** padding */
  padding: PropTypes.string,

  /** variants */
  variant: PropTypes.oneOf(Object.values(VARIANTS))
};
export default Object.assign(Container, {
  PLACEMENTS: PLACEMENTS,
  VARIANTS: VARIANTS
});

var _StyledDiv = _styled("div").withConfig({
  displayName: "Container___StyledDiv",
  componentId: "sc-ynihpb-0"
})(["", ""], function (p) {
  return p.$_css;
});
//# sourceMappingURL=Container.js.map